import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { TEmailTemplateSchema } from '@/schemas/email-template/email-template.schema';
import {
  ListAllEmailTemplate,
  TotalActiveEmailTemplate,
} from '../entities/email-template';
import { EmailTemplateFilter } from '@/entities/email-template';

const EMAIL_TEMPLATE_URI = '/emailTemplate';

export const createEmailTemplate = async (
  emailTemplate: TEmailTemplateSchema,
) => {
  return requestApi({
    url: EMAIL_TEMPLATE_URI,
    method: HTTP_METHOD.POST,
    body: emailTemplate,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getMatchingEmailTemplateError = async (
  query?: TEmailTemplateSchema,
) => {
  let url = `${EMAIL_TEMPLATE_URI}/matchingObjectError`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.platformTemplateId) {
    params.append('platformTemplateId', String(query.platformTemplateId));
  }

  if (query?.name) {
    params.append('name', query.name);
  }

  if (query?.type) {
    params.append('type', query.type);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllEmailTemplates = async (query?: ListAllEmailTemplate) => {
  let url = `${EMAIL_TEMPLATE_URI}/listAll`;
  const params = new URLSearchParams();

  if (query?.type) {
    params.append('type', query.type);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllEmailTemplates = async (
  filter: EmailTemplateFilter,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc',
) => {
  const params = new URLSearchParams();

  params.append('filter', JSON.stringify(filter));
  params.append('page', String(page));
  params.append('limit', String(limit));
  params.append('sortBy', String(sortBy || ''));
  params.append('sortDirection', String(sortDirection || 'asc'));

  return requestApi({
    url: `${EMAIL_TEMPLATE_URI}/all?${params.toString()}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveEmailTemplates = async (
  query?: TotalActiveEmailTemplate,
) => {
  let url = `${EMAIL_TEMPLATE_URI}/totalActive`;
  const params = new URLSearchParams();

  if (query?.type) {
    params.append('type', query.type);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getEmailTemplateById = async (id: string) => {
  return requestApi({
    url: `${EMAIL_TEMPLATE_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateEmailTemplate = async (
  emailTemplate: TEmailTemplateSchema,
) => {
  return requestApi({
    url: `${EMAIL_TEMPLATE_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: emailTemplate,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyEmailTemplates = async (
  emailTemplates: TEmailTemplateSchema[],
) => {
  return requestApi({
    url: `${EMAIL_TEMPLATE_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: emailTemplates,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
